import { EntityCondition } from "./EntityCondition";

export class EntityConditionImple extends EntityCondition {
  //項目選択
  public cnvType: number[] = [];
  //支払先の支払いサイト
  public supplierPaysite: number | null = null;
}
